import { parseDescriptionBlocks } from "@/lib/format";

/**
 * Renders a description as professional sections — key/value rows, bullet
 * lists and paragraphs — preserving the author's intent while making
 * long paragraphs readable. Used on ListingDetail, PublicListing, Issue
 * detail etc.
 */
export default function RichDescription({ text, className = "" }) {
  const blocks = parseDescriptionBlocks(text);
  if (!blocks.length) return (
    <p className={`text-gray-500 italic ${className}`}>No description provided.</p>
  );
  return (
    <div data-testid="rich-description" className={`space-y-3 ${className}`}>
      {blocks.map((b, i) => {
        if (b.kind === "spacer") return <div key={i} className="h-1" />;
        if (b.kind === "kv") {
          return (
            <div key={i} className="grid grid-cols-[120px_1fr] gap-3 items-baseline">
              <div className="text-[11px] uppercase tracking-widest text-gray-500 font-semibold">{b.label}</div>
              <div className="text-gray-800">{b.value}</div>
            </div>
          );
        }
        if (b.kind === "bullet") {
          return (
            <ul key={i} className="list-disc pl-6 space-y-1 text-gray-800">
              {b.items.map((it, j) => <li key={j}>{it}</li>)}
            </ul>
          );
        }
        return <p key={i} className="text-gray-800 leading-relaxed whitespace-pre-line">{b.text}</p>;
      })}
    </div>
  );
}
